const STORAGE_KEY = 'pm_last_activity_at';

export const SESSION_INACTIVITY_MS = 60 * 60 * 1000;

function readStoredActivity() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value ? Number(value) : null;
  } catch {
    return null;
  }
}

export let lastActivityTime = readStoredActivity() || Date.now();

export function updateLastActivity() {
  lastActivityTime = Date.now();
  try {
    localStorage.setItem(STORAGE_KEY, String(lastActivityTime));
  } catch {
    // localStorage kullanılamıyorsa bellekte tut
  }
}

export function getLastActivityTime() {
  const stored = readStoredActivity();
  if (stored) return stored;
  return lastActivityTime;
}

export function resetSessionActivity() {
  updateLastActivity();
}

export function clearSessionActivity() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  lastActivityTime = Date.now();
}
